

























import { listFactory } from '@/main/pages';
import { formatDate } from '@/main/utils/dateFormatter';
import { showAlert } from '@/main/utils/notifications';
import { isMultipleWorkshopSelected, getSearchButtonLabel, handleMultiWorkshopFilter, getCurrentLanguageId, validateDateFields} from '@/main/utils/commonFunctions';

import { NAME } from './constants';
import { store } from './store/list';
import { apiProvider } from './api';

export default listFactory(NAME, store).extend({
	data() {
		return {
			validateMessage: '',
			detailsOfItems: 'null' as string,
			workshops: [] as number[],
			fromDate: 'GrnStartDate',
			toDate: 'GrnEndDate',
		};
	},
	computed: {
		isMultipleWorkshopSelected(): boolean {
			return isMultipleWorkshopSelected(this.OrganizationIds);
		},
		searchButtonLabelKey(): string {
			return getSearchButtonLabel(this.OrganizationIds);
		},
	},
	methods: {
		async filterClick() {
			if (!validateDateFields(this, this.fromDate, this.toDate)) {
				return;
			}
			await handleMultiWorkshopFilter(
				this,
				NAME,
				this.OrganizationIds,
				(columnsSeq) => ({
					OrganizationIds: this.OrganizationIds,
					GrnStartDate: this.GrnStartDate,
					GrnEndDate: this.GrnEndDate,
					ColumnSequence: columnsSeq.join(','),
					LanguageId: getCurrentLanguageId(this.loggedUser.UzivatelData.LanguageId),
				}),
			);
		},
		async onWorkShopChange(workshopId: number[]) {
			if (workshopId !== undefined && workshopId !== null && !isMultipleWorkshopSelected(workshopId)) {
				this.WareHouseId = null;
				this.startLoading();
				const { data } = await apiProvider.GetWarehouseForItemTransfer(workshopId);
				this.dropdownList.WareHouseId = data;
				this.endLoading();
			} else {
				this.WareHouseId = null;
				this.dropdownList.WareHouseId = [];
			}
		},
		wareHouseUpdate() {
			const result = {} as any;
			this.dropdownList.WareHouseId.forEach((o: any) => {
				result[o.Value] = o.Text;
			});
		},

		dateValidation() {
			if (this.GrnStartDate && this.GrnEndDate) {
				const fromDate = new Date(this.GrnStartDate);
				const toDate = new Date(this.GrnEndDate);
				if (fromDate > toDate) {
					this.showErrorAlert({ message: this.LocalizePopisPoli('DP_FROM_DATE_LESS_THAN_TO_DATE') });
					this.GrnStartDate = null;
					this.GrnEndDate = null;
					return false;
				}
				const milisecondPerDay = 1000 * 60 * 60 * 24;

				const utc1 = Date.UTC(fromDate.getFullYear(), fromDate.getMonth(), fromDate.getDate());
				const utc2 = Date.UTC(toDate.getFullYear(), toDate.getMonth(), toDate.getDate());
				const dayDifference = Math.floor((utc2 - utc1) / milisecondPerDay);
				if (dayDifference > 365) {
					this.showErrorAlert({ message: this.LocalizePopisPoli('DP_365_DAY_DIFF') });
					this.GrnStartDate = null;
					this.GrnEndDate = null;
					return false;
				}
				return true;
			}
			return false;
		},

		validation(DateFrom: any, DateTo: any, workshopIds: any, WareHouseId: any) {
			this.detailsOfItems = `grnStartDate=${DateFrom}&grnEndDate=${DateTo}&wareHouseId=${WareHouseId}`;
			if (workshopIds.length > 0) {
				workshopIds.forEach((OrganizationId: any) => {
					this.detailsOfItems = this.detailsOfItems.concat(`&OrganizationIds=${OrganizationId}`);
				});
			}
			return this.detailsOfItems;
		},

		async exportFun() {
			try {
				if (this.filter.OrganizationIds == null || this.filter.OrganizationIds.length === 0) {
					this.showErrorAlert({ message: this.LocalizePopisPoli('DEALER_CODE_NOT_NULL') });
					return;
				}
				if (this.WareHouseId == null && !isMultipleWorkshopSelected(this.OrganizationIds)) {
					this.showErrorAlert({
						message: this.LocalizeChyboveHlasky('WareHouseIdCanNotBeNull'),
						options: { type: 'error' },
						localizeMessage: false,
					});
				} else {
					const columnsSeq = this.table.columns.filter(x => x.isVisible === true).map(x => x.columnName);
					this.startLoading();
					const params = this.validation(formatDate(new Date(this.GrnStartDate!).toISOString()),
						formatDate(new Date(this.GrnEndDate!).toISOString()), this.OrganizationIds, this.WareHouseId);

					if (this.isMultipleWorkshopSelected) {
						this.showErrorAlert({
							message: this.LocalizeChyboveHlasky('MultiWorkshopExportDisabled'),
						});
					} else {
						await apiProvider.GetItemsTransferDetailReport(params, columnsSeq, getCurrentLanguageId(this.loggedUser.UzivatelData.LanguageId));
					}
				}
			} catch (error)	{
				showAlert({
					message: this.LocalizeChyboveHlasky('LocalMsg'),
					title: this.LocalizeChyboveHlasky('DMS3_ErrorTitle'),
					options: {
						type: 'error',
					},
				});
			} finally {
				this.endLoading();
			}
		},
	},
});
